import clsx from 'clsx'
import { Checkbox, Divider, Select, Text } from 'components/common'

export interface FilterProps {
  onClick: () => void
}

export const FilterWithCheckbox = (props: FilterProps): JSX.Element => {
  // CheckBox On change Property
  const onChange = (e) => {
    console.log(`checked =${e.target.checked}`)
  }
  return (
    <>
      <div className={clsx('flex', 'justify-between', 'items-center')}>
        <div
          className={clsx('flex-auto', 'justify-start', 'items-center', 'ml-3')}
        >
          <Checkbox onChange={onChange}>
            <Text type="secondary">50件中、20件を表示</Text>
          </Checkbox>
        </div>
        <div className={clsx('flex', 'flex-auto', 'item-top', 'justify-end')}>
          <Select
            defaultValue="latestUpdate"
            className={clsx('justify-end', 'ml-2')}
          >
            <Select.Option value="latestUpdate">
              <Text type="secondary">並び替え 最終更新（新着順）</Text>
            </Select.Option>
          </Select>
        </div>
      </div>
      <Divider />
    </>
  )
}
